"use client"

import { Info } from "lucide-react"

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog"
import { useTranslations } from "next-intl"


interface TenantReactivationNoticeDialogProps {
  tenantName: string | null
  onOpenChange: (open: boolean) => void
}

export function TenantReactivationNoticeDialog({
  tenantName,
  onOpenChange,
}: TenantReactivationNoticeDialogProps) {
  const tUi = useTranslations("TenantManagement.TenantManagementTenantReactivationNoticeDialog")

  return (
    <AlertDialog open={tenantName !== null} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <div className="flex items-center gap-2">
            <Info className="h-5 w-5 text-blue-600" aria-hidden="true" />
            <AlertDialogTitle><span key={tUi("tenantActivated")}>{tUi("tenantActivated")}</span></AlertDialogTitle>
          </div>
          <AlertDialogDescription asChild>
            <div className="space-y-3">
              <p>
                <strong>{tenantName}</strong> <span><span key={tUi("canAccessItsWorkspaceAgain")}>{tUi("canAccessItsWorkspaceAgain")}</span></span>
              </p>
              <p>
                <span key={tUi("itsVoiceEmailAndMessagingAgentsRemainDisabled")}>{tUi("itsVoiceEmailAndMessagingAgentsRemainDisabled")}</span></p>
              <p>
                <span key={tUi("switchToThisTenantThenReactivateEveryAgent")}>{tUi("switchToThisTenantThenReactivateEveryAgent")}</span></p>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction><span key={tUi("understood")}>{tUi("understood")}</span></AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
